import {IUserAccessFeature} from '../user-access-features';
import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {SettingsReferenceEnum} from '../../../../settings-new/models';
import {_DEFAULT_USER_ACCESS_USER_PROFILE, IUserAccessUserProfile} from '../access';

//#region INTERFACE IFeatureUserProfile
export interface IFeatureUserProfile extends IUserAccessFeature, Object {
  crudAccess: IUserAccessUserProfile;
}

//#endregion

//#region CONST _FEATURE_USER_PROFILE_DEFAULT
export const _FEATURE_USER_PROFILE_DEFAULT: Readonly<IFeatureUserProfile & Object> = {
  displayText: NavigationPageEnumHumanReadable.UserProfile,
  feature: NavigationPageEnum.UserProfile,
  ref: SettingsReferenceEnum.accountUserProfile,
  standalone: true,
  crudAccess: {
    ..._DEFAULT_USER_ACCESS_USER_PROFILE,
  },
};
//#endregion
